// @ts-nocheck

import { colors } from '@lmc/common/constants'
import PropTypes from 'prop-types'
import React from 'react'
import { darken, lighten } from '../../../LEGACY/colorUtils'

export default function ProfileBadge({
  backgroundColor,
  badgeColor,
  badgeText,
  badgeStyle,
  textColor
}) {
  return (
    <div
      style={{
        ...badgeStyle,
        backgroundColor:
          backgroundColor ||
          (badgeColor ? lighten(badgeColor, 80) : lighten(colors.pink, 80)),
        color:
          textColor ||
          (badgeColor ? darken(badgeColor, 30) : darken(colors.pink, 30))
      }}
    >
      {badgeText}
    </div>
  )
}

ProfileBadge.propTypes = {
  backgroundColor: PropTypes.string,
  badgeColor: PropTypes.string,
  badgeStyle: PropTypes.object,
  badgeText: PropTypes.string,
  textColor: PropTypes.string
}
